import { AdminLayout } from '../components/AdminLayout';
import { Users2, Clock } from 'lucide-react';

export default function ReferralPage() {
  return (
    <AdminLayout title="Referral & Partnership" subtitle="Parrainage et partenariats">
      <div className="flex flex-col items-center justify-center py-24">
        {/* Decorative circles */}
        <div className="relative mb-8">
          <div className="w-24 h-24 bg-gradient-to-br from-[#16c47f]/10 to-emerald-100 dark:from-[#16c47f]/20 dark:to-emerald-900/20 rounded-full flex items-center justify-center">
            <Users2 className="w-10 h-10 text-[#16c47f]" />
          </div>
          <div className="absolute -top-2 -right-2 w-8 h-8 bg-amber-100 dark:bg-amber-900/30 rounded-full flex items-center justify-center">
            <Clock className="w-4 h-4 text-amber-500" />
          </div>
        </div>

        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">Coming Soon</h2>
        <p className="text-gray-500 dark:text-gray-400 text-center max-w-md mb-6">
          Le système de parrainage et de partenariats est en cours de développement. Cette section
          vous permettra de suivre les recommandations et collaborations.
        </p>

        <div className="flex items-center gap-2 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-xl px-4 py-2.5">
          <Clock className="w-4 h-4 text-amber-600 dark:text-amber-400" />
          <span className="text-sm font-medium text-amber-700 dark:text-amber-300">
            En développement
          </span>
        </div>
      </div>
    </AdminLayout>
  );
}
